const buildManagerInviteLink = code => `https://shopmy.us/signup?smscode=${encodeURIComponent(code)}&autoSubmitCode=true`;

module.exports = {
  buildManagerInviteLink
};
